import React from "react";
import PropTypes from "prop-types";
import "./index.css";

const iconStyles = {
  width: 26,
  height: 26,
  lineHeight: "26px",
  position: "absolute",
  top: 0,
  margin: 13,
  right: 4,
  fontSize: 14,
  textAlign: "center"
};

const iconThumbnail = {
  width: 26,
  height: 26,
  lineHeight: "26px",
  position: "absolute",
  top: 0,
  margin: 13,
  right: 4,
  backgroundColor: "#cbcdcf",
  fontSize: 14,
  textAlign: "center"
};

export const CategoryIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE896;</i>
  </span>
);
export const CollectionIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE8F0;</i>
  </span>
);
export const PageIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE873;</i>
  </span>
);
export const ProductIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE156;</i>
  </span>
);
export const MarketerIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE7EF;</i>
  </span>
);
export const TransferIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE3E7;</i>
  </span>
);
export const EditorIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE896;</i>
  </span>
);
export const TicketIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE53F;</i>
  </span>
);
export const PaymentIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE227;</i>
  </span>
);
export const SimIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE0D4;</i>
  </span>
);
export const ActivationIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE8AC;</i>
  </span>
);

export const TextIcon = ({ title }) => (
  <span style={iconThumbnail}>{title}</span>
);

export const AgencyIcon = () => (
  <span style={iconStyles}>
    <i className="material-icons">&#xE896;</i>
  </span>
);
TextIcon.propTypes = { title: PropTypes.string.isRequired };
TextIcon.defaultProps = { title: "" };



// WEBPACK FOOTER //
// ./src/menu/icon/index.js